'use strict'
import Vue from 'vue'
import axios from 'axios'
import { Toast } from 'vant'
import router from '@/router'
import store from '@/store/'
import LocalStorage from '@/utils/localStorage'

const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
    // 允许所有域名访问
    'Access-Control-Allow-Origin': '*',
    // 是否允许后续请求携带认证信息（cookies）,该值只能是true,否则不返回
    'Access-Control-Allow-Credentials': 'true'
  },
  withCredentials: true
})

// request拦截器
request.interceptors.request.use(
  config => {
    // console.log('config', config)
    // 携带鉴权请求头
    const Authorization = store.state.token
    if (Authorization) {
      config.headers.Authorization = Authorization
    }
    return config
  },
  error => {
    // Do something with request error
    Promise.reject(error)
  }
)

// response 拦截器
request.interceptors.response.use(
  response => {
    const result = response.data
    // 请求异常 - 待完善
    if (result.code !== 100) {
      switch (result.code) {
        case 506: // 登陆令牌缺失
          loginOut()
          break
        case 502: // 登陆令牌非法
          loginOut()
          break
        case 503: // 登陆令牌失效
          loginOut()
          break
        default:
          _error(result.msg)
          break
      }
      Vue.prototype.$loading.hide() // 关闭加载动画
      return Promise.reject(result.msg || 'error')
    } else {
      return result
    }
  },
  error => {
    Vue.prototype.$loading.hide() // 关闭加载动画
    return Promise.reject(error)
  }
)

// 跳转登录页面，并清除缓存
function loginOut () {
  LocalStorage.clear()
  router.replace('/login')
}

// 接口调用若没写错误回调，则执行_error方法
function _error (errMsg) {
  Toast({
    message: errMsg || '系统请求错误',
    icon: require('@/assets/images/icon/error.png'),
  })
}
export default request
